<template>
  <div>
    <!-- Continer Summary Section Start -->
    <div></div>
    <b-button
      v-if="!isIcon && allModuleId > 0"
      class="mb-1 mt-1"
      @click="showContainerModal(allModuleId)"
      size="xs"
      style="font-size: 0.675rem"
      >Container Summary</b-button
    >
    <b-button v-else-if="isIcon && allModuleId > 0"
        @click="showContainerModal(allModuleId)" 
        size="sm" 
        variant="outline-dark" 
        class="mr-1 btn-action"
        v-b-tooltip.hover title="Container Summary"
    >
        <i :class="iconClass || 'fa fa-cube'"></i>
    </b-button>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Container-modal"
      hide-footer
      :title="Page_title"
    >
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <b-row>
        <b-col md="12">
          <b-button
            class="pull-right mb-1"
            v-if="ContainerList.length > 0"
            :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
            @click="getReports('getJobContainerDetails', 'Export As Excel')"
            size="xs"
            style="font-size: 0.675rem"
            variant="warning"
          >
            {{ ExcelBtnName }}
            <b-spinner
              v-if="ExcelBtnName != 'Export As Excel'"
              small
              label="Small Spinner"
            ></b-spinner
          ></b-button>
          <b-table
            show-empty
            stacked="md"
            :items="ContainerList"
            :fields="Containerfields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              <span
                v-if="row0.item.rollover_event_code == 1"
                :class="{
                  alert: true,
                  'alert-danger-text': row0.item.rollover_event_code == 1,
                  blink: row0.item.rollover_event_code == 1,
                }"
                ><br />This Container No Rollover</span
              >
            </template>
          </b-table>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            class="mt-3"
            variant="outline-danger"
            size="xs"
            style="font-size: 0.675rem"
            @click="hideContainerModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>

  <!-- Continer Summary Section End -->
</template>

<script>
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },
    PMC_JOBID: {
      type: String,
      default: "",
    },
    PMC_JOBNO: {
      type: String,
      default: "",
    },
    PMC_JOBDATE: {
      type: String,
      default: "",
    },
    PMC_JOBTYPE: {
      type: String,
      default: "",
    },
    PMC_AgentType: {
      type: String,
      default: "",
    },
    PMC_Client: {
      type: String,
      default: "",
    },
    PMC_Sline: {
      type: String,
      default: "",
    },
    isIcon: {
        type: Boolean,
        default: false
    },
    iconClass: {
        type: String,
        default: ''
    }
  },
  beforeMount() {
    if (this.PMC_JOBID) {
      // this.getContainer();
    }
  },
  mounted() {},

  data() {
    return {
      Page_title: this.PMC_title,
      isLoading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 300,
      pageOptions: [100, 200, 300],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      Containerfields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "containerType",
          mainkey: "containerType",
          label: "Container Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          label: "Container No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sub_noti_event_message",
          mainkey: "sub_noti_event_message",
          label: "Event MSG",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "LineSealNo",
          mainkey: "LineSealNo",
          label: "Line Seal",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "customSealNo",
          mainkey: "customSealNo",
          label: "Custom Seal",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "INVNO",
          mainkey: "INVNO",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "INVDATE",
          mainkey: "INVDATE",
          label: "Shipper Inv Date",
          sortable: true,
          sortDirection: "ASC",
          table: "G.",
        },

        {
          key: "BOENO",
          mainkey: "BOENO",
          label: "BOE",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },
        {
          key: "BOEDATE",
          mainkey: "BOEDATE",
          label: "BOE Date",
          sortable: true,
          sortDirection: "ASC",
          table: "I.",
        },
        {
          key: "netWeight",
          mainkey: "netWeight",
          label: "Net Wgt.",
          sortable: true,
          sortDirection: "ASC",
          table: "J.",
        },
        {
          key: "grossWeight",
          mainkey: "grossWeight",
          label: "Gross Wgt.",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "tareWeight",
          mainkey: "tareWeight",
          label: "Tare Wgt.",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "weightUnit",
          mainkey: "weightUnit",
          label: "Unit",
          sortable: true,
          sortDirection: "ASC",
          table: "M.",
        },
        {
          key: "measurement",
          mainkey: "measurement",
          label: "Measurement",
          sortable: true,
          sortDirection: "ASC",
          table: "N.",
        },
        {
          key: "packageName",
          mainkey: "packageName",
          label: "Package",
          sortable: true,
          sortDirection: "ASC",
          table: "O.",
        },
        {
          key: "noOfpkgUnit",
          mainkey: "noOfpkgUnit",
          label: "No.of Package",
          sortable: true,
          sortDirection: "ASC",
          table: "P.",
        },
        {
          key: "GRNSeries",
          mainkey: "GRNSeries",
          label: "GRN Series",
          sortable: true,
          sortDirection: "ASC",
          table: "Q.",
        },
        {
          key: "GRNDATE",
          mainkey: "GRNDATE",
          label: "GRN DATE",
          sortable: true,
          sortDirection: "ASC",
          table: "R.",
        },
      ],
      ContainerList: [],
      allModuleId: this.PMC_JOBID,
      // isLoading: false,
      ExcelBtnName: "Export As Excel",
      docURL: URL_BASE_DOC,
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getContainer("Normal");
      },
      deep: true,
    },
  },
  methods: {
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getContainer("Excell");
    },
    getContainer(type) {
      this.ContainerList = [];
      let payload = {};
      if (this.PMC_JOBID) {
        if (type == "Normal") {
          this.isLoading = true;
        }
        payload = {
          itemCode: "getJobContainerDetails",
          allModuleId: this.PMC_JOBID,
          type: type,
        };

        CommonService.getAllJobList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data.ContainerListFLAG == 1) {
              if (type == "Excell") {
                if (data.ContainerList.length > 0) {
                  this.ContainerList = data.ContainerList;
                }

                this.ExcelBtnName = "Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              } else {
                if (data.ContainerList.length > 0) {
                  this.ContainerList = data.ContainerList;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on ContainerList Error: ", error);
          });
      }
    },

    showContainerModal(allModuleId) {
      this.ContainerList = [];
      this.$refs["Container-modal"].show();
      this.getContainer("Normal");
      // this.isLoading = false;
    },
    hideContainerModal() {
      this.ContainerList = [];
      this.$refs["Container-modal"].hide();
      // this.isLoading = false;
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
.alert-danger-text {
  /* background-color: #d9534f; Bootstrap danger color */
  color: #d9534f; /* Bootstrap danger color */
}
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1s infinite; /* Adjust the duration as needed */
}
</style>



// WEBPACK FOOTER //
// moduleBasedContaierSummary.vue?065cef57